import React from 'react';
import Lottie from 'react-lottie';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Popup from '../../../common/Popup';
import { DOCUMENTATION_TYPES } from '../../../../constants';
import UploadInsuranceCard from '../../../../assets/images/lotties/UploadInsuranceCard.json';

import styles from './index.styl';

const animationOptions = {
  loop: true,
  autoplay: true,
  animationData: UploadInsuranceCard,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const UploadingInsuranceCardModal = ({ isOpened, cardType }) => {
  const { formatMessage } = useIntl();

  const isFrontSideCard = cardType === DOCUMENTATION_TYPES.CARD_1;

  const title = formatMessage({
    id: isFrontSideCard
      ? 'profile.loadingPopup'
      : 'profile.insuranceCard.uploading',
  });

  if (!isOpened) return null;

  return (
    <Popup opened={isOpened} withHeading={false} mobileFullScreen={false}>
      <div className={styles.root}>
        <Lottie options={animationOptions} height={200} width={200} />
        <div className={styles.message}>{title}</div>
      </div>
    </Popup>
  );
};

UploadingInsuranceCardModal.propTypes = {
  isOpened: PropTypes.bool,
  cardType: PropTypes.string,
};
export default UploadingInsuranceCardModal;



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/InsuranceDetails/UploadingInsuranceCardModal/index.jsx